import React from 'react';
import Overlay from "react-bootstrap/Overlay";
import Popover from "react-bootstrap/Popover";
import store from "../../store";
import {toggleHelpPopovers} from "../../actions/userActions";
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import {hotProps} from "../../lib/constants";

const Translate = require('react-redux-i18n').Translate;


const stateMap = (store) => {
    return {
        userReducer: store.userReducer,
    };
};

 class  HotSpot extends React.Component {
    constructor(props) {
        super(props)
        this.overlayContainerRef = React.createRef();
        this.toggleHotSpot = this.toggleHotSpot.bind(this)
        this.closeHotPopovers = this.closeHotPopovers.bind(this)
    }

    componentWillMount() {
        this.closeHotPopovers();
    }

    closeHotPopovers() {
        hotProps.forEach(elProp => {
            store.dispatch(toggleHelpPopovers("showHelp__" + elProp, false))
        })
    }

    toggleHotSpot(hotProp) {
            store.dispatch(toggleHelpPopovers("showHelp__" + hotProp, !this.props.userReducer["showHelp__" + hotProp]));
            hotProps.forEach(elProp => {
                if (elProp !== hotProp && this.props.userReducer["showHelp__" + elProp]) {
                        store.dispatch(toggleHelpPopovers("showHelp__" + elProp, false))
                }
            })
    }

    render() {
        let show = this.props.userReducer["showHelp__" + this.props.hotProp];
        const currImage = this.props.image ? require('../../../assets/img/help/' + this.props.image + '.gif') : undefined;
        return (
            <React.Fragment>
                {!this.props.userReducer['hide__' + this.props.hotProp] ?
                    <div className={"hotspot__wrapper hotspot__" + this.props.hotProp}
                            ref={this.overlayContainerRef}>
                        <div className = "hotspot "
                             onClick={(e) => {
                                 e.stopPropagation()
                                 this.toggleHotSpot(this.props.hotProp)
                                 this.setState({
                                     target: e.target,
                                 });
                             }}>
                            {show ?
                                <i className="icon-x-icon hotspot__close"
                                   onClick={() => {this.toggleHotSpot(this.props.hotProp)}}
                                /> : null}
                        </div>
                    </div>:null}
                <Overlay
                    rootClose={false}
                    show={show}
                    placement={this.props.placement}
                    target={this.state?.target ?? this.overlayContainerRef}
                    container={this.overlayContainerRef}
                    containerPadding={20}>
                    <Popover 
                        id={"hotSpot-popover__" + (this.props.hotProp)}
                        onClick={(e) => {
                            e.stopPropagation()
                        }}
                        className={"hot-popover__" + this.props.hotProp}>
                        <Popover.Body>
                            {currImage &&
                                <img className="hot-popover-image"
                                     src={currImage}
                                     alt={this.props.image + " help tooltip"} />
                            }
                            <Translate value={"hotSpots."+(this.props.hotProp)} dangerousHTML/>
                        </Popover.Body>
                    </Popover>
                </Overlay>
            </React.Fragment>
        )
    }
}

export default withRouter(connect(stateMap)(HotSpot));
